export default "__VITE_ASSET__BB1NHWna__"